import { useNavigate } from 'react-router-dom'
import kinesisLogo from 'media/kinesis_logo.png'

import ScreenFrame from 'components/Frame/ScreenFrame'
import SolidButton from 'components/Buttons/SolidButton'

export default function RouteNotFoundView() {
    const navigate = useNavigate()

    return (
        <ScreenFrame>
            <div className='max-w-xl mx-auto p-4 space-y-4'>
                <img 
                    src={kinesisLogo} 
                    alt="Kinesis Logo" 
                    className="w-60 mx-auto" 
                />

                <div className="text-center font-bold text-2xl mb-4">Oops. Wrong turn..</div>

                <div className="text-center">The page you are looking for does not exist</div>

                <div className='py-4'>
                    <SolidButton
                        size='large'
                        text='Return to Home'
                        action={() => navigate('/home')}
                        className='shadow-md'
                    />
                </div>

                <p className='pt-4 text-center text-gray-600'>
                    Need more support? Contact us at <a href="mailto:support@kinesisintegrated.com" className="text-blue-500 underline">support@kinesisintegrated.com</a>
                </p>
            </div>
        </ScreenFrame>
    )
}